/* Happy Caps — wraps hero+tiles in a shared solid-color band. No animation. */
(function () {
  function groupAtmos() {
    var grouped = {};
    document.querySelectorAll('[data-hc-atmos-group]').forEach(function (el) {
      var key = el.dataset.hcAtmosGroup;
      (grouped[key] = grouped[key] || []).push(el);
    });
    Object.keys(grouped).forEach(function (key) {
      var nodes = grouped[key];
      if (!nodes.length) return;
      var parent = nodes[0].parentNode;
      var wrap = document.createElement('div');
      wrap.className = 'hc-atmos-band';
      wrap.setAttribute('data-hc-atmos-wrap', key);
      parent.insertBefore(wrap, nodes[0]);
      nodes.forEach(function (n) { wrap.appendChild(n); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupAtmos);
  } else {
    groupAtmos();
  }
})();
